import { brl, pct } from "@/lib/format";
import { monthLabel, share, variation } from "@/lib/dre";

const ROW = { total: "font-semibold", sub: "font-semibold", item: "caption", result: "font-bold text-base" };

function Val({ v }) {
  return <span className="tnum" style={{ color: v < 0 ? "var(--danger)" : undefined }}>{brl(v)}</span>;
}

function Var({ cur, prev, k }) {
  const v = variation(cur, prev);
  if (v === null) return <span className="caption">—</span>;
  const costLine = !["receita_bruta", "receita_liquida", "lucro_bruto", "ebitda", "ebit", "lucro_liquido", "outras_receitas"].includes(k);
  const good = costLine ? v <= 0 : v >= 0;
  return <span className="caption tnum font-semibold" style={{ color: good ? "var(--success, #2f7d4f)" : "var(--danger)" }}>{v > 0 ? "+" : ""}{pct(v)}</span>;
}

export function DreTable({ d }) {
  const cur = d.current.values, prev = d.previous.values;
  return (
    <div className="card overflow-x-auto" style={{ padding: 0 }} data-testid="dre-table">
      <table className="w-full text-sm min-w-[640px]">
        <thead>
          <tr className="caption uppercase text-left" style={{ background: "var(--surface-alt)" }}>
            <th className="px-4 py-3">Demonstração do resultado</th>
            <th className="px-3 py-3 text-right">{monthLabel(d.current.month)}</th><th className="px-3 py-3 text-right">% receita</th>
            <th className="px-3 py-3 text-right">{monthLabel(d.previous.month)}</th><th className="px-3 py-3 text-right">% receita</th>
            <th className="px-4 py-3 text-right">Variação</th>
          </tr>
        </thead>
        <tbody>
          {d.lines.map((l) => (
            <tr key={l.key} className={`border-t ${ROW[l.kind]}`} style={{ borderColor: "var(--border)", background: l.kind === "result" ? "var(--brand-soft)" : l.kind === "total" ? "var(--surface-alt)" : undefined }} data-testid={`dre-line-${l.key}`}>
              <td className={`py-2.5 ${l.kind === "item" ? "pl-9 pr-4" : "px-4"}`}>{l.label}</td>
              <td className="px-3 py-2.5 text-right" data-testid={`dre-value-${l.key}`}><Val v={cur[l.key]} /></td>
              <td className="px-3 py-2.5 text-right caption tnum">{pct(share(cur[l.key], cur.receita_bruta))}</td>
              <td className="px-3 py-2.5 text-right"><Val v={prev[l.key]} /></td>
              <td className="px-3 py-2.5 text-right caption tnum">{pct(share(prev[l.key], prev.receita_bruta))}</td>
              <td className="px-4 py-2.5 text-right"><Var cur={cur[l.key]} prev={prev[l.key]} k={l.key} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
